import { useState } from "react";
import { bulkApplySipClients } from "../../../admin/api";
import { useAdminDataRefresh } from "../dataRefresh/AdminDataRefreshContext";
import { useAdminNotifications } from "../notifications/AdminNotificationsContext";
import { useSessionSipActivity } from "../sessionActivity/SessionSipActivityContext";
import { getWorkspaceSelectionKey, prepareUniqueSipItems } from "../workspaceSelection/workspaceSelectionUtils";
import { useWorkspaceSelection } from "../workspaceSelection/WorkspaceSelectionContext";

export default function BulkSipApplyAction({ items, onApplied, buttonStyle }) {
  const [isSaving, setIsSaving] = useState(false);
  const { invalidate } = useAdminDataRefresh();
  const { notify } = useAdminNotifications();
  const { recordChanges } = useSessionSipActivity();
  const { updateSnapshots } = useWorkspaceSelection();

  const apply = async () => {
    const selected = prepareUniqueSipItems(items);
    if (!selected.length || !window.confirm(`Запустить выбранных клиентов: ${selected.length}?`)) return;
    try {
      setIsSaving(true);
      const response = await bulkApplySipClients({
        sourceSection: "clients",
        items: selected.map((item) => ({ complexId: item.complexId, embeddedSipClientId: item.sipClientId })),
      });
      const successful = response.results.filter((item) => item.ok);
      updateSnapshots(successful.map((item) => ({ key: item.key, snapshot: { complexStatus: true, currentSipClientId: item.sipClientId } })));
      const selectedByKey = new Map(selected.map((item) => [getWorkspaceSelectionKey(item), item]));
      recordChanges(successful.filter((item) => item.changed).map((item) => ({
        ...selectedByKey.get(item.key),
        changedFields: ["currentSipClientId", "status", "type", "transfer_number", "sip_number", "preset"],
        snapshot: { ...selectedByKey.get(item.key)?.snapshot, complexStatus: true, currentSipClientId: item.sipClientId },
      })), "bulk-apply");
      if (successful.length) invalidate(["complexes", "sip", "transfers"]);
      onApplied?.(response.results);
      notify(`Запуск клиентов: ${response.changed} изменено, ${response.unchanged} без изменений, ${response.failed} ошибок`, response.failed ? "partial" : "success");
    } catch (error) {
      notify(error instanceof Error ? error.message : "Не удалось запустить клиентов", "error");
    } finally {
      setIsSaving(false);
    }
  };

  return <button type="button" style={buttonStyle} disabled={isSaving || !items.length} onClick={apply}>{isSaving ? "Запуск…" : "Запустить выбранных клиентов"}</button>;
}
